import menu from './menu'
import error from './error'
import cardSelect from './cardSelect'
import iframe from './iframe'
import bookings from './bookings/main'
import baseCalendar from './baseCalendar'

export default {
    menu,
    error,
    cardSelect,
    iframe,
    bookings,
    baseCalendar,

    yes: "Ja",
    no: "Nein",

    on: "An",
    off: "Aus",
    from: "von",
    to: "bis",
    useTime: 'Verwende Uhrzeiten',
    daysInclusive: 'Anfangs- und Endtag einschließlich',
}
